import React from 'react'
import { Text } from 'theme-ui'
import TextList from '@components/TextList'
import { FaRegClock } from 'react-icons/fa'
import rv from '@components/utils/buildResponsiveVariant'

export const translateDateBlog = (date) => {
  const dateCard = date.split(" ")

  const month = dateCard[0]
  const day = dateCard[1].replace(',', '')
  const year = dateCard[2]

  let translatedMonth

  switch (month) {
    case 'January':
      translatedMonth = 'Enero'
      break;
    case 'February':
      translatedMonth = 'Febrero'
      break;
    case 'March':
      translatedMonth = 'Marzo'
      break;
    case 'April':
      translatedMonth = 'Abril'
      break;
    case 'May':
      translatedMonth = 'Mayo'
      break;
    case 'June':
      translatedMonth = 'Junio'
      break;
    case 'July':
      translatedMonth = 'Julio'
      break;
    case 'August':
      translatedMonth = 'Agosto'
      break;
    case 'September':
      translatedMonth = 'Septiembre'
      break;
    case 'October':
      translatedMonth = 'Octubre'
      break;
    case 'November':
      translatedMonth = 'Noviembre'
      break;
    case 'December':
      translatedMonth = 'Diciembre'
      break;
  }

  return `${day} de ${translatedMonth} del ${year}`
}

const CardFooterInfo = ({ variant, date, timeToRead }) => (
  <TextList nowrap>
    {date && <Text sx={{ variant: rv(variant, 'date'), color: '#FFF' }}>{translateDateBlog(date)}</Text>}
      {/* ESTO AGREGA EL RELOJ */}
    {/* {timeToRead && (
      <Text sx={{ variant: rv(variant, 'timeToRead'), color: '#6B6767' }}>
        <FaRegClock css={{ verticalAlign: `middle`, color: '#6B6767' }} /> {timeToRead} min
      </Text>
    )} */}
  </TextList>
)

export default CardFooterInfo
